import { useLineKeyContext } from '../store/line-key-provider';

export const DeviceLayoutFooter = () => {
  const { device } = useLineKeyContext();

  return <div className={`device-model-layout-footer ${device?.model === 't57w' && 'touch-screen'}`}></div>;
};
